import axiosInstance from "../../../../config/apiConfig";
import { useMutation, useQueryClient } from '@tanstack/react-query';


const blockUser = async ({ userId, blockedById, reason = null }) => {
  try {
    const { data } = await axiosInstance.patch(`reports/${userId}/toggle-block?adminId=${blockedById}&reason=${reason}` );
  
    return data;
  } catch (err) {
    console.error('Failed to block user:', err.response?.data || err.message);
    throw err;
  }
};


 const useBlockUser = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: blockUser,
    onSuccess: () => {
      queryClient.invalidateQueries(['blockedUsers']);
    },
    onError: (err) => {
      console.error('Block user mutation failed:', err);
    },
  });
};

export default useBlockUser